import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private http:HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      "accept": "application/json;odata=Nometadata",
      "content-type": "application/json;odata=verbose"
    })
  };
  cssOptions = {
    headers: new HttpHeaders({
      "accept": "text/css;charset=utf-8",
      "content-type": "text/css;charset=utf-8"
    })
  };

  
  get(url):Observable<string>{
    return this.http.get(url,{responseType: 'text'});
  }
  getMenu(url){
    return this.http.get(url+"/_api/web/lists/GetByTitle('Menu')/items?"
    +"$select=Id,Title,ApplicationUrl,MenuNiveau,Ordre,ParentId,MegaMenu&$filter=MenuPrincipal eq 1",this.httpOptions);
  }
  getMenuEspacePro(url){
    return this.http.get(url+"/_api/web/lists/GetByTitle('Menu')/items?"
    +"$select=Id,Title,ApplicationUrl,MenuNiveau,Ordre,ParentId,MegaMenu&$filter=MegaMenu eq 'EspacePro'",this.httpOptions);
  }
  getSubMenu(url, id){
    return this.http.get(url+"/_api/web/lists/GetByTitle('Menu')/items?"
    +"$select=Id,Title,ApplicationUrl,MenuNiveau,Ordre,ParentId,MegaMenu&$filter=ParentId eq " +id,this.httpOptions);
  }
  getMenuPageTitle(url){
    return this.http.get(url+"/_api/web/lists/GetByTitle('MenuNavigation')/items?"
    +"$select=*",this.httpOptions);
  }  
  getBlocDescriptionByCode(url,code){
    return this.http.get(url+"/_api/web/lists/GetByTitle('BlocsDescription')/items?"
    +"$filter=Code eq '"+code+"'",this.httpOptions);
  }
  getLexique (url) {
    return this.http.get(url+"/_api/web/lists/GetByTitle('Lexique')/items?"
    +"",this.httpOptions);
  
  }
  getPasserelle (url) {
    return this.http.get(url+"/_api/web/lists/GetByTitle('Passerelle')/items?"
    +"$select=*,File/ServerRelativeUrl,ContentType/Name&$expand=File,ContentType&$orderby=Annee desc",this.httpOptions);
  
  }
}